import { Component, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import $ from "jquery";

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoaderComponent implements AfterViewInit {

    public ngAfterViewInit(): void {

        $('.section-loader').fadeOut('slow');
    }
}
